<template>
	<div>
		<div class="page-title">
        <!-- <img src="@/assets/images/meta.svg" width="24" alt style="margin-right: 12px"/> -->
        <span>图表订阅</span>
        <a-button class="create-btn" type="primary" @click="addClick">新增</a-button>
				<a-button class="filter-btn btn-tertiary" @click="filterVisible = !filterVisible"> 
					<icon-font type="icon-Filter1"  /><span>筛选</span>
				</a-button>
		</div>
		<!-- <a-tabs v-model="activeKey" class="page-tabs">
			<a-tab-pane key="data" tab="Meta数据"></a-tab-pane>
		</a-tabs> -->
		<!-- <div v-if="activeKey === 'account'">
			<MediaAccount code="FB"></MediaAccount>
		</div> -->
		<div v-if="activeKey === 'data'">
			<chartSubData ref="content" code="FB" :filterVisible="filterVisible"></chartSubData>
		</div>
	</div>
</template>
<script>
import chartSubData from "./components/chartSubData.vue"

export default {
	name: 'Meta',
	data() {
		return {
			filterVisible: false,
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
		}
	},
	methods: {
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
    addClick(){
      this.$refs.content.addClick()
    }
	},
	components: {
		chartSubData,
	}
}
</script>
<style lang="less" scoped>
	.page-tabs {
		margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>